export const GHGActivitiesIcon = ({ color = '#109F40', size = 40 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 44 44"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M39.8337 16.5389C39.8947 18.4 39.8947 20.5516 39.8947 23.0526C39.8947 31.9853 39.8947 36.4505 37.12 39.2253C34.3453 42 29.8779 42 20.9474 42C12.0168 42 7.54947 42 4.77474 39.2253C2 36.4505 2 31.9832 2 23.0526C2 14.1221 2 9.65474 4.77474 6.88C7.54947 4.10526 12.0168 4.10526 20.9474 4.10526C23.4484 4.10526 25.6 4.10526 27.4611 4.16632M42 6.21053C42 7.32723 41.5564 8.39819 40.7668 9.18782C39.9771 9.97745 38.9062 10.4211 37.7895 10.4211C36.6728 10.4211 35.6018 9.97745 34.8122 9.18782C34.0226 8.39819 33.5789 7.32723 33.5789 6.21053C33.5789 5.09383 34.0226 4.02286 34.8122 3.23323C35.6018 2.44361 36.6728 2 37.7895 2C38.9062 2 39.9771 2.44361 40.7668 3.23323C41.5564 4.02286 42 5.09383 42 6.21053Z"
			stroke={color}
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.3158 23.0526H13.579L17.7895 14.6316L24.1053 31.4737L28.3158 23.0526H33.579"
			stroke={color}
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
